import * as React from "react";
import arrowUp from "./../../../assets/arrowUp.png";
import arrowDown from "./../../../assets/arrowDown.png";
import deleteImage from './../../../assets/bulkdelete.png';
import tags from "./../../../assets/tags.png";
import "./MasterTableTab.css";
import TableComponent from "../../components/tableComponent/tableComponent/tablecomponent";
import ApproveRequest from "../requestApproval/requestApproval";
import axios from "axios";
import baseConfig from "../../../config/config";
import * as XLSX from "xlsx";
import { tableFormat } from "../../../config/tableFormat";
import copy from "clipboard-copy";
import MailModal from "../mail/mail";
import BulkUpdate from "../bulk_update/bulkupdate";
import bulkUpdateImg from "./../../../assets/bulkUpdate.png";
import mailImg from "./../../../assets/mail.png";
import addImg from "./../../../assets/add.png";
import exportImg from "./../../../assets/exportImg.png";
import linkImg from "./../../../assets/copyLink.png";
import { useNavigate } from "react-router-dom";
import GPUTable from "../gpuTable/GPUTable";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTableData,
  getDistinctDataThroughSingleApi,
} from "../../../redux/actions/actions";
import {
  updateTableDataByRequestId,
  updateAllManagedTableData,
  handleManualAllocation,
  updateGPUData,
} from "../../../redux/reducers/rootReducer";

import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import Detail from "../detail/detail";
import Filters from "../../filters/Filters";
import Alert from "../../components/alert/alert";
import UpdateTags from "../updateTags/UpdateTags";
import { getUniqueParam } from "../../components/helpers";

const moment = extendMoment(originalMoment);

function MasterTableTab() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [preFiterSelected, setPreFilterSelected] = React.useState([]);
  const [regionSums, setRegionSums] = React.useState([]);
  const unModifiedTableDataReducer = useSelector((state) => state.managedTableData.unchangedTableData);
  const [openApprovalModal, setOpenApproveModal] = React.useState(false);
  const [openTagUpdate, setOpenTagUpdate] = React.useState(false);
  const [openAddEntryModal, setOpenAddEntryModal] = React.useState(false);
  const [openDeleteAlertModal, setOpenDeleteAlertModal] = React.useState(false);
  const [showBackDrop, setShowBackDrop] = React.useState(false);
  const [capacityAllocation, setCapacityAllocation] = React.useState(false);
  const [tableData, setTableData] = React.useState([]);
  const [newTab, setnewTab] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedOption, setSelectedOption] = React.useState(false);
  const [openBulkUpdate, setOpenBulkUpdate] = React.useState(false);
  const [OpenMailModel, setOpenMailModel] = React.useState(false);
  const [selectAll, setSelectAll] = React.useState(false);
  const [copyLinkText, setCopyLinkText] = React.useState("Copy Link");
  const [deleteSuccess, setDeleteSuccess] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false)
  const [deleteFailure, setDeleteFailure] = React.useState(false);
  const GPUData = useSelector(store => store.GPUData.GPUData !== undefined ? store.GPUData.GPUData : []);
  const autoManualRef = React.useRef();
  const allCustomer = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .Customers !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .Customers?.map((item) => ({
        value: item["Key"],
        label: item["Value"],
      }))
      : []
  );
  const allTags = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
  .Tag !== undefined
  ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
  .Tag?.map((item) => ({
    value: item["Value"],
    label: item["Value"],
  }))
  : []
);
  const allRI = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RI !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RI?.map((item) => ({
        value: item["Value"],
        label: item["Value"],
      }))
      : []
  );
  const regionOptions = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RegionAllocatedOptions !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RegionAllocatedOptions?.map((item) => ({
        value: item["Key"],
        label: item["Value"],
      }))
      : []
  );
  const regionNeededOptions = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RegionNeeded !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RegionNeeded?.map((item) => ({
        value: item["Key"],
        label: item["Value"],
      }))
      : []
  );
  const gpuWiseRegionData = useSelector(store => store.GPUData.gpuWiseRegionData !== undefined ? store.GPUData.gpuWiseRegionData : []);

  const UATIDs = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .UAT_ID !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
        .UAT_ID
      : [])
  const [selectedGPU, setSelectedGPU] = React.useState(null);



    // Common for all date filters
  const[selectedDates, setSelectedDates] = React.useState({
    RequestDate: "",
    EarmarkedDate: "",
    FullyAllocatedDate: ""
  })
  const [dateContentValues, setDateContentValues] =
    React.useState({
      RequestDate: "",
      EarmarkedDate: "",
      FullyAllocatedDate: ""
    });
    const [showDateCalender, setShowDateCalender] =
    React.useState({
      RequestDate: false,
      EarmarkedDate: false,
      FullyAllocatedDate: false
    });
    const [datePickerValues, setDatePickerValues] =
    React.useState({
      RequestDate: "",
      EarmarkedDate: "",
      FullyAllocatedDate: ""
    });
    const [dateRenderKeys, setDateRenderKeys] = React.useState(0);

    const onDateSelect = (datePickerValue, dateField) => {
      setDatePickerValues({
        ...datePickerValues,
        [dateField]: datePickerValue,
      });
      const formattedValue = `${datePickerValue.start.format(
        "MM/DD/YYYY"
      )} - ${datePickerValue.end.format("MM/DD/YYYY")}`;
      setDateContentValues({
        ...dateContentValues,
        [dateField]: formattedValue,
      });

      const startDate = formatDate(datePickerValue.start.format("YYYY-MM-DD"));
      const endDate = formatDate(datePickerValue.end.format("YYYY-MM-DD"));
      handleDateChange(startDate, endDate, dateField);
    };
    const handleDateChange = (startDate,endDate, property) => {
    
      const fetchdate = {
        property: property,
        startDateValue: startDate,
        endDateValue: endDate,
      };
      setSelectedDates({...selectedDates, [property]: fetchdate})
  
      const preselectedFilter = preFiterSelected;
  
      const dateIndex = preselectedFilter.findIndex(
        (item) => item.property === property
      );
  
      if (dateIndex !== -1) {
        if (!selectedOption) {
          preFiterSelected.splice(dateIndex, 1);
        } else {
          preselectedFilter[dateIndex].startDateValue = startDate;
          preselectedFilter[dateIndex].endDateValue = endDate;
        }
      } else {
        preselectedFilter.push({
          property: property,
          startDateValue: startDate,
          endDateValue: endDate,
        });
      }
  
      sessionStorage.setItem(
        "gpuFilter",
        JSON.stringify(preselectedFilter)
      );
      setPreFilterSelected(preselectedFilter);
      fetchData(fetchdate);
      setSelectAll(false);
      setShowDateCalender({...showDateCalender, [property]: false});
    }
    const clearDateSelect = (dateField) => {
      setDatePickerValues({...datePickerValues, [dateField]: null})
      setDateContentValues({...dateContentValues, [dateField]: ""})
      setDateRenderKeys({...dateRenderKeys, [dateField]: (dateRenderKeys[dateField] + 1)})
      setShowDateCalender({...showDateCalender, [dateField]: false})

      setSelectedDates({...selectedDates, [dateField]:null })
      const preselectedFilter = preFiterSelected;

      const dateIndex = preselectedFilter.findIndex(
        (item) => item.property === dateField
      );
  
      if (dateIndex !== -1) {
        preFiterSelected.splice(dateIndex, 1);
      }
  
      sessionStorage.setItem(
        "gpuFilter",
        JSON.stringify(preselectedFilter)
      );
      setPreFilterSelected(preselectedFilter);
  
      fetchData("clear", dateField);
      setSelectAll(false);
    };


    const [filterValues, setFilterValues] = React.useState({
      CustomerName: "",
      RequestStatus: "",
      UAT_ID: "",
      Tag: "",
      RegionNeeded: "",
      DC_RegionAllocated: "",
      AIGBB: "",
      RI: "",
    })
    const handleFilterChange = async (selectedOption, property) => {
      const preselectedFilter = preFiterSelected;
  
      const FilterIndex = preselectedFilter.findIndex(
        (item) => item.property === property
      );
  
      
      if (FilterIndex !== -1) {
        if (!selectedOption) {
          preFiterSelected.splice(FilterIndex, 1);
        } else {
          selectedOption.property = property;
          preselectedFilter[FilterIndex] = selectedOption;
        }
      } else {
        if (selectedOption) {
          selectedOption.property = property;
          preselectedFilter.push(selectedOption);
        }
      }
      if (!selectedOption) {
        selectedOption = { value: "", label: "" };
        setFilterValues({...filterValues, [property]: ""});
      } else {
        setFilterValues({...filterValues, [property]: selectedOption});
      }

      sessionStorage.setItem(
        "gpuFilter",
        JSON.stringify(preselectedFilter)
      );
      setPreFilterSelected(preselectedFilter);
  
      selectedOption.property = property;
      fetchData(selectedOption);
      // setSelectedIndex(null);
      setSelectAll(false);
    };

  const [showGPUAvailable, setShowGPUAvailable] = React.useState(false);

  const requestStateOption = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RequestStatus !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RequestStatus?.map((item) => ({
        value: item["Key"],
        label: item["Value"],
      }))
      : []
  );
  const requestGrantedStatusOptions = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RequestGrantStatus !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RequestGrantStatus
      : null
  );
  const gbbRegionOptions = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .GBBRegion !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
        .GBBRegion?.map((item) => ({
          value: item["Key"],
          label: item["Value"],
        }))
      : null
  );
  const gpuNameOptions = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .GPU !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
        .GPU
      : []
  );

  const isDistinctDataThroughSingleApiLoaded = useSelector(
    (store) =>
      store.distinctDataThroughSingleApi.isDistinctDataThroughSingleApiLoaded
  );

  const distinctDataThroughSingleApiError = useSelector(
    (store) =>
      store.distinctDataThroughSingleApi.distinctDataThroughSingleApiError
  );

  const [isReadyForUpdate, setIsRaedyForUpdate] = React.useState(true);
  const [approvalError, setApprovalError] = React.useState("");


  const [loader, setLoader] = React.useState(false);
  const [tableLoader, setTableLoader] = React.useState(true);

  const setSelectAllChange = (value) => {
    setSelectAll(value);
  };
  const [isCtrlActive, setIsCtrlActive] = React.useState(false);
  

  const tableDataReducer = useSelector((state) => state.tableData.tableData);
  const isTableDataLoaded = useSelector(
    (state) => state.tableData.isTableDataLoaded
  );
  const isTableDataError = useSelector(
    (state) => state.tableData.isTableDataError
  );
  const [selectedGPUOptions, setSelectedGPUOptions] = React.useState([]);
  

  function formatDate(dateString) {
    if (dateString.includes("/")) {
      return dateString;
    }
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${month}/${day}/${year}`;
    }
    return "";
  }


  const [openGPUSelect, setOpenGPUSelect] = React.useState(false);
  const openGpuSelectRef = React.useRef();
  const handleGPUChange = async (selectedGPUOptions) => {
    setSelectedGPUOptions(selectedGPUOptions);
    const preselectedFilter = preFiterSelected;
    const modelIndex = preselectedFilter.findIndex(
      (item) => item.property === "GPU_Name"
    );

    if (modelIndex !== -1) {
      if (!selectedGPUOptions) {
        preFiterSelected.splice(modelIndex, 1);
      } else {
        preselectedFilter[modelIndex] = {
          property: "GPU_Name", 
          value: selectedGPUOptions,
        };
      }
    } else {
      if (selectedGPUOptions) {
        preselectedFilter.push({
          property: "GPU_Name",
          value: selectedGPUOptions,
        });
      }
    }

    sessionStorage.setItem(
      "gpuFilter",
      JSON.stringify(preselectedFilter)
    );
    setPreFilterSelected(preselectedFilter);

    if (!selectedGPUOptions) {
      selectedGPUOptions = [{ value: "", label: "" }];
      setSelectedGPU({ property: "GPU_Name", value: "" });
    } else {
      setSelectedGPU({
        property: "GPU_Name",
        value: selectedGPUOptions?.map((item) => item.label),
      });
    }
    fetchData(selectedGPUOptions, "GPU_Name");
    // setSelectedIndex(null);
    setSelectAll(false);
  };



  const closeConfirmationModal = (data) => {
    
    setOpenApproveModal(false);
    setShowBackDrop(false);
  };


  const closeBulkUpdate = () => {
    setOpenBulkUpdate(false);
    setShowBackDrop(false);
  };

  const openMailModal = () => {
    setOpenMailModel(true);
    setShowBackDrop(true);
  };

  const closeMailModal = () => {
    setOpenMailModel(false);
    setShowBackDrop(false);
  };
  const openAddModal = () => {
    setOpenAddEntryModal(true);
    setShowBackDrop(true);
  };
  const openDeleteAlert = () => {
    setOpenDeleteAlertModal(true);
    setShowBackDrop(true);
  };
  const openTagsUpdateModal = () => {
    setOpenTagUpdate(true);
    setShowBackDrop(true);
  };

  const closeDeleteAlert = () => {
    setOpenDeleteAlertModal(false);
    setShowBackDrop(false);
  };
  const closeTagUpdate = () => {
    setOpenTagUpdate(false);
    setShowBackDrop(false);
  };

  const closeAddModal = () => {
    setOpenAddEntryModal(false);
    setShowBackDrop(false);
  };

  const openApproval = () => {
    if (selectedIndex && selectedIndex.length > 0) {
      setOpenApproveModal(true);
      setShowBackDrop(true);
      mergeData();
    }
  };

  const openBulkUpdateModal = () => {
    setOpenBulkUpdate(true);
    setShowBackDrop(true);
  };

  const handleCapacityChange = () => {
    if (autoManualRef.current.value !== 'Manual') {
      showToast("Please choose manual mode", "danger");
    } else if (selectedIndex?.length === 0 || selectedIndex === null) {
      showToast("Please select Requests", "danger");
    }
    setCapacityAllocation(true);
  }
  const mergeData = () => {
    if (newTab) {
      const newData = [...newTab];
      if (selectedIndex && selectedIndex.length > 0) {
        selectedIndex.forEach((id, i) => {
          const indexNew = newData.findIndex((item) => item.RequestID === id);
          const indexEdi = tableDataReducer.findIndex(
            (item) => item.RequestID === id
          );
          newData[indexNew] = tableDataReducer[indexEdi];
        });
      }
      setSelectedData(newData);
    } else {
      setSelectedData(newTab);
    }
  };

  const handletableChange = (event, id, label, row) => {
    const prevData = JSON.parse(JSON.stringify([...tableDataReducer]));
    let prevDataIndex = prevData.findIndex((item) => item.RequestID === id);
    const prevIndex = prevData[prevDataIndex];
    const newData = JSON.parse(JSON.stringify([...tableDataReducer]));
    let newIndex = newData.findIndex((item) => item.RequestID === id);
    const gpuSelected =
    label === "GPU_Name" ? event.target.value :  prevData[prevDataIndex]['GPU_Name'];
    if(label === "GPUsAllocated"){
    if(event.target.value == prevData[prevDataIndex]['GPUsAllocated'])
      return
    }
    let filter = newData?.filter((item) => item.RequestID === id);
    const index = newData[newIndex];
    
    if (index) {
      if (event?.target) {
        if (label === "DC_RegionAllocated") {
          index["DC_RegionAllocated"] = event.target.value;
        } else  if (label === "GPUsAllocated") {
          index["GPUsAllocated"] = event.target.value === "" ? 0 : event.target.value ;
        }else{
          index["DC_RegionAllocated"] = filter[0].DC_RegionAllocated;
          index[label] = event.target.value;
        }
      } else {
        index[label] = event;
      }
    }

    if (label === "GPU_Name") {
      handleTabClick(gpuSelected, Object.keys(GPUData).indexOf(gpuSelected)); 


     
      const inputElementRegionGranted = document.getElementById(
        `DC_RegionAllocated_${id}`
      );


        index["DC_RegionAllocated"] = "";
        index["GPUsAllocated"] = "0"; 
        const inputElementGPU_Granted = document.getElementById(
          `GPUsAllocated_${id}`
        );
        if (inputElementGPU_Granted) {
          inputElementGPU_Granted.value = "0";
        }
        if (inputElementRegionGranted) {
          inputElementRegionGranted.value = "";
        }
      index["GPU_Name"] = gpuSelected;
      
    }
      if(prevIndex['RequestStatus'] && prevIndex['GPU_Name'] && prevIndex['DC_RegionAllocated']){
        const previousGPURegionData = gpuWiseRegionData[prevIndex.GPU_Name];
        if (previousGPURegionData) {
          const previousRegionData = previousGPURegionData.filter(
            (item) => item === prevIndex.DC_RegionAllocated
          );
          if (previousRegionData[0]) {
            
            dispatch(
              handleManualAllocation({
                oldObject: prevIndex,
                newObject: filter[0],
              })
            )
          }
        }
      }

    dispatch(
      updateTableDataByRequestId({ requestId: id, updatedObject: filter[0] })
    );
  };

  const handleSelectedIndex = (index) => {
    setSelectedIndex(index);
  };

  const getAllData = async () => {
    setCapacityAllocation(false);
    if (!isTableDataLoaded) {
      await dispatch(fetchTableData());
    }
  };
  React.useEffect(() => {

    return () => {
      if (unModifiedTableDataReducer.length > 0) {
        dispatch(
          updateAllManagedTableData(unModifiedTableDataReducer)
        )
      }
    };
  }, [unModifiedTableDataReducer])


  const isDateWithinRange = (recordedDate, providedValues) => {
    const startDate = moment(providedValues.startDateValue, "MM/DD/YYYY");
    const endDate = moment(providedValues.endDateValue, "MM/DD/YYYY");
    const recorded = moment(recordedDate, "MM/DD/YYYY");

    return recorded.isBetween(startDate, endDate, null, "[]");
  };


  const  fetchData = async (selected, property, sessionData) => {
    setCapacityAllocation(false);
    setTableLoader(true)
    let postData;
    if(!sessionData){
      postData = {
        CustomerName: filterValues.CustomerName?.value || "",
        RequestDate: selectedDates.RequestDate || "",
        RequestStatus: filterValues.RequestStatus?.value || "",
        UAT_ID: filterValues.UAT_ID?.value || "",
        GPU_Name: selectedGPU?.value || "",
        Tag: filterValues.Tag?.value || "",
        EarmarkedDate: selectedDates.EarmarkedDate || "",
        RegionNeeded: filterValues.RegionNeeded?.value || "", //Region Requssted
        DC_RegionAllocated: filterValues.DC_RegionAllocated?.value || "",
        AIGBB: filterValues.AIGBB?.value || "",
        RI: filterValues.RI?.value || "",
        FullyAllocatedDate: selectedDates.FullyAllocatedDate || "",
      };
    } else {
      postData = sessionData;
      for (let key in postData) {
        if (
          /date/i.test(key) &&
          typeof postData[key] === "string" &&
          postData[key].includes(" - ")
        ) {
          const [startDate, endDate] = postData[key].split(" - ");
          postData[key] = {
            startDateValue: startDate,
            property: key,
            endDateValue: endDate,
          };
        }
      }
  
      setSelectedOption(postData);
    }
   
    const defaultPostData = {
      CustomerName: "",
        RequestDate:  "",
        RequestStatus:  "",
        UAT_ID:  "",
        GPU_Name: "",
        Tag:  "",
        EarmarkedDate:  "",
        RegionNeeded:  "", //Region Requssted
        DC_RegionAllocated:  "",
        AIGBB: "",
        RI:  "",
        EarmarkedDate: "",
        FullyAllocatedDate: "",
      
    };
    if (selected === "clear") {
      if (!property) {
        setFilterValues({
          CustomerName: "",
          RequestStatus: "",
          UAT_ID: "",
          Tag: "",
          RegionNeeded: "",
          DC_RegionAllocated: "",
          AIGBB: "",
          RI: "",
        });
        setDateContentValues({
          RequestDate: "",
          EarmarkedDate: "",
          FullyAllocatedDate: "",
        });
        setDatePickerValues({
          RequestDate: "",
          EarmarkedDate: "",
          FullyAllocatedDate: "",
        });
        setSelectedGPU(null);
        setSelectedGPUOptions([]);
        sessionStorage.removeItem("gpuFilter");
        setTableData(tableDataReducer);
        setnewTab(tableDataReducer);
        return  setTableLoader(false);
      }
      postData[property] = "";
   
    } else if (property) {
      postData[property] = selected.map((option) => option.label);
    } else if (selected && selected.property?.toLowerCase().includes("date")) {
      postData[selected.property] = selected["value"]
        ? selected.value
        : selected;
    } else if (selected) {
      postData[selected.property] = selected["value"];
    }
    function matchesProvidedObject(record) {
      for (let key in postData) {
        if (postData.hasOwnProperty(key) && record.hasOwnProperty(key)) {
          const providedValue = postData[key];
          const recordValue = record[key];

          if ([ "CustomerName", "RequestStatus", "UAT_ID" ,"DC_RegionAllocated"].includes(key)) {

            if (
              typeof providedValue === "string" &&
              typeof recordValue === "string"
            ) { 
              const trimmedProvidedValue = providedValue.trim();
              const trimmedRecordValue = recordValue.trim();
              if (
                trimmedProvidedValue.toLowerCase() !==
                defaultPostData[key].toLowerCase() &&
                trimmedProvidedValue.toLowerCase() !==
                trimmedRecordValue.toLowerCase()
              ) {
                return false;
              }
            }
          } else if (key === "GPU_Name") {
            if (Array.isArray(providedValue) && providedValue.length === 0) {
              continue;
            }
            if (Array.isArray(providedValue)) {
              const providedLabels = providedValue;
              if (!providedLabels.some((label) => label === recordValue)) {
                return false;
              }
            }
          } else if ([ "RI", "AIGBB", "Tag" ].includes(key)) {
            if (
              typeof providedValue === "string" &&
              typeof recordValue === "string"
            ) {
              const providedLower = providedValue.toLowerCase();
              const recordLower = recordValue.toLowerCase();
              if (!recordLower.includes(providedLower)) {
                return false;
              }
            }
          } else if (/date/i.test(key)) {
            if (
              providedValue.startDateValue &&
              typeof recordValue === "string"
            ) {
              const isInRange = isDateWithinRange(recordValue, providedValue);
              if (!isInRange) return false;
            }
          } else {

            if (
              providedValue != defaultPostData[key] &&
              providedValue != recordValue
            ) {
              return false;
            }
          }
        }
      }
      return true;
    }
    const filteredTableData = tableDataReducer.filter(matchesProvidedObject);
    setTableData(filteredTableData);
    setnewTab(filteredTableData);
    setTableLoader(false);
  };

  const getVanityURl = async (url) => {
    const postData = {
      URL: JSON.stringify(url),
    };
    let csrfToken=localStorage.getItem("csrfToken")
    const config = {
      headers: {
        "content-type": "application/json",
        serviceid: sessionStorage.getItem("userToken"),
        "X-CSRF-Token": csrfToken
      },
      withCredentials: true,
    };

    try {
      const response = await axios.post(
        baseConfig.apiBaseUrl + "/vanity/url/get/key",
        postData,
        config
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) {
        navigate("/errorPage");
      }
    }
  };

  const fetchDataForFilters = (filter) => {
    try {
  
      if (!isDistinctDataThroughSingleApiLoaded) {
        dispatch(getDistinctDataThroughSingleApi());
      } else {
        setLoader(false);
      }
  
      if (!filter) {
        setTableData(tableDataReducer);
        setTableLoader(false);
        setnewTab(tableDataReducer);
        return;
      }
  
      const postData = {
        CustomerName: "",
        RequestDate:  "",
        RequestStatus:  "",
        UAT_ID:  "",
        GPU_Name: "",
        Tag:  "",
        EarmarkedDate:  "",
        RegionNeeded:  "", //Region Requssted
        DC_RegionAllocated:  "",
        AIGBB: "",
        RI:  "",
        EarmarkedDate: "",
        FullyAllocatedDate: "",
      };
  
      setPreFilterSelected(filter);
  
      let sessionfilterValues = {
        CustomerName: "",
        RequestStatus: "",
        UAT_ID: "",
        Tag: "",
        RegionNeeded: "",
        DC_RegionAllocated: "",
        AIGBB: "",
        RI: "",
        
      }
      let sessiondateContentValues = {
        RequestDate: "",
        EarmarkedDate: "",
        FullyAllocatedDate: ""
      }
      let sessionDatePickerValues = {
        RequestDate: "",
        EarmarkedDate: "",
        FullyAllocatedDate: ""
      }
      filter.forEach((item) => {
        const { property, value, startDateValue, endDateValue } = item;
        
        if (/date/i.test(property)) {
          if(startDateValue && endDateValue){
            const formattedValue = `${startDateValue} - ${endDateValue}`;
            sessiondateContentValues[property] = formattedValue;
            
            const startDate = moment(startDateValue, "MM/DD/YYYY");
            const endDate = moment(endDateValue, "MM/DD/YYYY");
            const range = moment.range(startDate, endDate);
            sessionDatePickerValues[property] = range;
            
            postData[property] = formattedValue;
          }
          
        } else if (property === "GPU_Name" && value?.length > 0) {
          setSelectedGPU({ property: property, value: value?.map((item) => item.label)});
          setSelectedGPUOptions(value)
          postData[property] = value?.map((item) => item.label);
        } else {
          if(value){
            postData[property] = value;
            sessionfilterValues[property] = { label: value, value: value , property: property};
          }
          
        }
      });
      setFilterValues({...sessionfilterValues});
      setDateContentValues(sessiondateContentValues)
      setDatePickerValues({...sessionDatePickerValues})
      // Set the selected options
      setSelectedOption(postData);
  
      // Fetch data
      fetchData("", "", postData);
  
      setTimeout(() => setLoader(false), 1000);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  

  const handleLinkClick = async () => {
    setCopyLinkText("Copying...");
    const uniqueParam = getUniqueParam();
    let url = `${window.location.origin}/Home/`;
    const json = [
      ...Object.entries(filterValues)
        .filter(([_, value]) => value?.value !== "") 
        .map(([key, value]) => ({ property: key, value: value?.value })), 
        ...Object.entries(dateContentValues)
    .filter(([_, value]) => value !== "") 
    .map(([key, value]) => {
      const [startDate, endDate] = value.split(" - "); 
      return { property: key, startDateValue: startDate, endDateValue: endDate };
    }),
      selectedGPU && { property: "GPU_Name", value: selectedGPUOptions },
      { property: "gpumaster", value: "gpumaster" },
      { property: "tab", value: "1" },
    ].filter(Boolean);
    
   
    if (json.length > 0) {
      try {
        const filteredJson = json.filter(
          (item) =>
            !(
              item.value === "" ||
              item.value === null ||
              (Array.isArray(item.value) && item.value.length === 0)
            )
        );
        
        const vanityId = await getVanityURl(filteredJson);
        url += vanityId + `?visit=${uniqueParam}`;
      } catch (error) {
        console.error("Error generating vanity URL: ", error);
        setCopyLinkText("Copy Failed");
        return;
      }
    }
  
    try {
      await copy(url);
      setCopyLinkText("Copied");
      setTimeout(() => setCopyLinkText("Copy Link"), 5000);
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  };
  

  const handleTableDataChange = (value) => {
    setnewTab(value);
  };

  const decodeVanityURl = async () => {
    const copyLinkUuid = sessionStorage.getItem("copyLinkuuid");
    const userToken = sessionStorage.getItem("userToken");
    const gpuFilter = sessionStorage.getItem("gpuFilter");
  
    if (!copyLinkUuid) {
      fetchDataForFilters(gpuFilter ? JSON.parse(gpuFilter) : []);
      setTableLoader(false);
      return;
    }
  
    try {
      const response = await axios.get(
        `${baseConfig.apiBaseUrl}/vanity/url/get/value?id=${copyLinkUuid}`,
        {
          headers: {
            "content-type": "application/json",
            serviceid: userToken,
          },
        }
      );
  
      if (response.status === 200) {
        const data = JSON.parse(response.data);
        const tabValue = data.find((item) => item.property === "tab")?.value;
        const filters = gpuFilter
          ? JSON.parse(gpuFilter)
          : tabValue === "2"
          ? data
          : [];
  
        fetchDataForFilters(filters);
      }
    } catch (error) {
      console.error(error);
      setPreFilterSelected(null);
  
      if (error.response?.status === 401) {
        navigate("/errorPage");
      }
    } finally {
      setTableLoader(false);
    }
  };
  




  React.useEffect(() => {

    getAllData();
    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey) {
        setIsCtrlActive(true);
      }
    });
    document.addEventListener("keyup", (e) => {
      if (!e.ctrlKey) {
        setIsCtrlActive(false);
      }
    });
    
  }, []);


  React.useEffect(() => {
    if (!isDistinctDataThroughSingleApiLoaded) {
      dispatch(getDistinctDataThroughSingleApi());
    } else if (isTableDataLoaded) {
      decodeVanityURl();
    }
  }, [isDistinctDataThroughSingleApiLoaded, isTableDataLoaded]);





  const [rowErrors, setRowErrors] = React.useState(
    Array(tableData?.length).fill("")
  );
  const [errorLabel, setErrorLabel] = React.useState(
    Array(tableData?.length).fill("")
  );



  const [activeTab, setActiveTab] = React.useState(0);

 
  const handleTabClick = (gpuName, index) => {
    setActiveTab(index);
  };
 
 
  const hasContributor = sessionStorage.getItem("ActiveRole")?.includes('Contributor');
  React.useEffect(() => {
    if (
      distinctDataThroughSingleApiError ||
      isTableDataError
    ) {
      navigate("/errorPage");
    }
  }, [
    distinctDataThroughSingleApiError,
    isTableDataError
  ]);
 
  const triggerExport = () => {
    const selectedEntries = [];

    for (const item of tableData) {
      if (selectedIndex.includes(item.RequestID)) {
        selectedEntries.push(item);
      }
    }

    const excelData = selectedEntries.map((item) => {
      const newItem = {};
      for (const column of tableFormat.keys) {
        if (item[column] == -1) {
          newItem[column] = "NA";
        } else {
            newItem[column] = item[column];
        }
      }
      return newItem;
    });

    const data = [
      tableFormat.headerLabels,
      ...excelData.map((item) => Object.values(item)),
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelFile = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "base64",
    });

    const link = document.createElement("a");
    link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelFile}`;
    link.download = "GPUs Report.xlsx";
    link.click();
  };
  const deleteRecord = async () => {
    setDeleting(true);
    let postData = {
        "RequestIDs": selectedIndex
    };

    try {
        let csrfToken=localStorage.getItem("csrfToken")
        const apiEndpoint = '/request/bulk/delete';
        const response = await axios.post(
            baseConfig.apiBaseUrl + apiEndpoint,
            postData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    "serviceid": sessionStorage.getItem("userToken"),
                    "X-CSRF-Token": csrfToken
                },
                withCredentials: true,
            }
        );
        if (response.status === 200) {
            setDeleting(false);
            setDeleteSuccess(true);
            showToast("Requests Deleted Successfully.", "success");
            setTimeout(() => {
                setDeleteSuccess(false);
                window.location.reload();
            }, 2000);
        }

    } catch (error) {
        console.error('API Error:', error);
        setDeleting(false);
        setDeleteFailure(true);
        showToast("Failed To Delete Requests. Try again.", "danger");
        setTimeout(() => {
            setDeleteFailure(false);
        }, 3000);
        if (error.response?.status === 401) {
            navigate("/errorPage");
        }
    }
};
  function showToast(message, type) {
    const toaster = document.createElement("div");
    toaster.className = `toaster ${type}-toaster`;
    toaster.style.position = "fixed";
    toaster.style.top = "5%";
    toaster.style.left = "50%";
    toaster.style.transform = "translateX(-50%)";

    toaster.style.height = "25px";
    toaster.style.maxWidth = "300px";
    toaster.style.zIndex = 999;

    toaster.innerText = message;

    document.body.appendChild(toaster);
    setTimeout(() => {
      toaster.remove();
    }, 2000);
  }
  const filtersArray = [
    {
      type: "dropdown",
      id: "customer",
      label: "Customer Name ",
      placeholder: "Choose Customer Name ",
      value: filterValues.CustomerName,
      options: allCustomer,
      onChange: (selectedOption) => handleFilterChange(selectedOption, "CustomerName"),
      zIndex:'999'
    },
    {
      type: "dateRange",
      id: "request-date",
      label: "Request Date",
      placeholder: "Choose Date",
      value: dateContentValues.RequestDate
        ? {
            value: dateContentValues.RequestDate,
            label: dateContentValues.RequestDate,
          }
        : "",
      onChange: () => clearDateSelect('RequestDate'),
      setShowCalender: (value) => setShowDateCalender(prev => ({ ...prev, RequestDate: value })),
      showCalender: showDateCalender.RequestDate,
      pickerValue: datePickerValues.RequestDate,
      renderKey: dateRenderKeys.RequestDate,
      onDateSelect: (value) => onDateSelect(value, "RequestDate"),
      datePickerValue: datePickerValues.RequestDate,
    },
    {
      type: "dropdown",
      id: "request-state",
      label: "Request Status",
      placeholder: "Choose Status",
      value: filterValues.RequestStatus,
      options: requestStateOption?.map((item) => ({
        value: item["label"],
        label: item["label"],
      })),
      onChange: (selectedOption) => handleFilterChange(selectedOption, "RequestStatus"),
      zIndex:'999'
    },
    {
      type: "dropdown",
      id: "uat",
      label: "UAT ID",
      placeholder: "Choose UAT ID",
      value: filterValues.UAT_ID,
      options:  UATIDs?.map((item) => ({
        value: item["Value"],
        label: item["Key"],
      })),
      onChange: (selectedOption) => handleFilterChange(selectedOption, "UAT_ID"),
      zIndex:'999'
    },
    {
      type: "multiSelectDropdown",
      id: "gpu-dropdown",
      label: "GPU's",
      placeholder: "Choose GPU's",
      ref: { openGpuSelectRef },
      openDropdown: openGPUSelect,
      onClick: () => setOpenGPUSelect(!openGPUSelect),
      value: selectedGPUOptions,
      options: gpuNameOptions?.map((item) => ({
        value: item["Key"],
        label: item["Value"],
      })),
      onChange: handleGPUChange,
      zIndex:'999'
    },
    {
      type: "dropdown",
      id: "Tag",
      label: "Tag",
      placeholder: "Choose Tag",
      value: filterValues.Tag,
      options: allTags  ?.map((item) => ({
        value: item["value"],
        label: item["value"],
      })),
      onChange: (selectedOption) => handleFilterChange(selectedOption, "Tag"),
      zIndex:'998'
    },
    
    {
      type: "dropdown",
      id: "region-needed",
      label: "Region Requested",
      placeholder: "Choose Region",
      value: filterValues.RegionNeeded,
      options: regionNeededOptions?.map((item) => ({
        value: item["value"],
        label: item["value"],
      })),
      onChange: (selectedOption) => handleFilterChange(selectedOption, "RegionNeeded"),
      zIndex:'998'
    },
    {
      type: "dropdown",
      id: "region-allocated",
      label: "DC Region(Allocated)",
      placeholder: "Choose Region",
      value: filterValues.DC_RegionAllocated,
      options: regionOptions?.map((item) => ({
        value: item["value"],
        label: item["value"],
      })),
      onChange: (selectedOption) => handleFilterChange(selectedOption, "DC_RegionAllocated"),
      zIndex:'998'
    },
    {
      type: "inputText",
      label: "AIGBB",
      placeholder: "Search...",
      value: filterValues.AIGBB?.value || "",
      onChange: (event) => handleFilterChange({label:event.target.value, value: event.target.value}, "AIGBB"),
    },
    {
      type: "dropdown",
      id: "RI",
      label: "RI",
      placeholder: "Choose RI",
      value: filterValues.RI,
      options: allRI?.map((item) => ({
        value: item["value"],
        label: item["value"],
      })),
      onChange: (selectedOption) => handleFilterChange(selectedOption, "RI"),
      zIndex:'998'
    },
    {
      type: "dateRange",
      id: "date-needed",
      label: "Earmarked Date ",
      placeholder: "Choose Date",
      value: dateContentValues.EarmarkedDate
        ? {
            value: dateContentValues.EarmarkedDate,
            label: dateContentValues.EarmarkedDate,
          }
        : "",
      onChange: () => clearDateSelect('EarmarkedDate'),
      setShowCalender: (value) => setShowDateCalender(prev => ({ ...prev, EarmarkedDate: value })),
      showCalender: showDateCalender.EarmarkedDate,
      pickerValue: datePickerValues.EarmarkedDate,
      renderKey: dateRenderKeys.EarmarkedDate,
      onDateSelect: (value) => onDateSelect(value, "EarmarkedDate"),
      datePickerValue: datePickerValues.EarmarkedDate,
    },
   
    {
      type: "dateRange",
      id: "fully-allocated-date",
      label: "Fully Allocated Date",
      placeholder: "Choose Date",
      value: dateContentValues.FullyAllocatedDate
        ? {
            value: dateContentValues.FullyAllocatedDate,
            label: dateContentValues.FullyAllocatedDate,
          }
        : "",
      onChange: () => clearDateSelect('FullyAllocatedDate'),
      setShowCalender: (value) => setShowDateCalender(prev => ({ ...prev, FullyAllocatedDate: value })),
      showCalender: showDateCalender.FullyAllocatedDate,
      pickerValue: datePickerValues.FullyAllocatedDate,
      renderKey: dateRenderKeys.FullyAllocatedDate,
      onDateSelect: (value) => onDateSelect(value, "FullyAllocatedDate"),
      datePickerValue: datePickerValues.FullyAllocatedDate,
    },
  ];
  return (
    <>
      {!loader && (
        <>
        <Filters
          filterList={filtersArray}
          onClearAll={() => {
            fetchData("clear");
            setPreFilterSelected([]);
            sessionStorage.removeItem('gpuFilter')
          }}
        />

          <hr className="horizontal-divider" />

          <div className="heading-container">
            <div
              className="sub-heading"
              style={{ padding: "0px", margin: "0px" }}
            >
              GPUs Available
            </div>
            <div style={{ marginLeft: "auto" }}>
              {showGPUAvailable ? (
                <div
                  className="image-container"
                  style={{ paddingRight: "20px", cursor: "pointer" }}
                  onClick={() => {
                    setShowGPUAvailable(false);
                  }}
                >
                  <img src={arrowUp} alt="Filter Icon" />
                </div>
              ) : (
                <div
                  className="image-container"
                  style={{ paddingRight: "20px", cursor: "pointer" }}
                  onClick={() => {
                    setShowGPUAvailable(true);
                  }}
                >
                  <img src={arrowDown} alt="Filter Icon" />
                </div>
              )}
            </div>
          </div>

          <div style={{padding:"10px", display: showGPUAvailable ? "flex" : "none", flexDirection:"column", justifyContent:"space-evenly" }}>
          <GPUTable
              handleTabClick={handleTabClick}
              activeTab={activeTab}
              gpuData={GPUData}
              capacityAllocation={capacityAllocation}
              setApprovalError={setApprovalError}
            />
          </div>


          <hr className="horizontal-divider" />
          <div className="feature-container">
            {
             (hasContributor)&& (
                <>
                  <div className="feature-buttons">
                    <button
                      className="tooltip-button"
                      onClick={openAddModal}
                    >
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={addImg}
                          alt="Filter Icon"
                          style={{
                            height: "20px",
                            width: "20px",
                            marginRight: "4px",
                          }}
                        />
                        Add Request
                      </span>
                      <span className="tooltip-text">Add Request</span>
                    </button>
                  </div>
 
                  <div className="button-separator"></div>
                  <div className="feature-buttons">
                    <button
                      className="tooltip-button"
                      onClick={openDeleteAlert}
                      disabled={!selectedIndex || selectedIndex.length === 0}
                    >
                      <span style={{ display: "flex", alignItems: "center" }}>
                      <img src={deleteImage} alt="Filter Icon"
                          style={{
                            height: "20px",
                            width: "20px",
                            marginRight:"2px"
                          }}></img>
                        Delete Requests
                      </span>
                      <span className="tooltip-text">Delete Requests</span>
                    </button>
                  </div>
                  <div className="button-separator"></div>
                </>
              )
            }

            <div className="feature-buttons">
              <button
                className="tooltip-button"
                onClick={openMailModal}
                disabled={!selectedIndex || selectedIndex.length === 0}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={mailImg}
                    alt="Filter Icon"
                    style={{
                      height: "20px",
                      width: "20px",
                      marginRight: "5px",
                    }}
                  />
                  Send Mail
                </span>
                <span className="tooltip-text">Send Mail</span>
              </button>
            </div>

            <div className="button-separator"></div>

            <div className="feature-buttons">
              <button
                disabled={copyLinkText !== "Copy Link" ? true : false}
                className="tooltip-button"
                onClick={handleLinkClick}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={linkImg}
                    alt="Filter Icon"
                    style={{
                      height: "20px",
                      width: "20px",
                      marginRight: "7px",
                    }}
                  />{copyLinkText}
                </span>
                <span className="tooltip-text">{copyLinkText}</span>
              </button>
            </div>

            <div className="button-separator"></div>

            <div onClick={triggerExport} className="feature-buttons">
              <button
                className="tooltip-button"
                disabled={!selectedIndex || selectedIndex.length === 0}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={exportImg}
                    alt="Filter Icon"
                    style={{
                      height: "20px",
                      width: "20px",
                      marginRight: "4px",
                    }}
                  />
                  Export Excel
                </span>
                <span className="tooltip-text">Export Excel</span>
              </button>
            </div>
            {(hasContributor)&& (
              <>
                <div className="button-separator"></div>

                <div onClick={openBulkUpdateModal} className="feature-buttons">
                  <button
                    className="tooltip-button"
                    disabled={!selectedIndex || selectedIndex.length === 0}
                  >
                    {" "}
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={bulkUpdateImg}
                        alt="Filter Icon"
                        style={{
                          height: "15px",
                          width: "15px",
                          marginRight: "7px",
                        }}
                      />
                      Bulk Update
                    </span>
                    <span className="tooltip-text">Bulk Update</span>
                  </button>
                </div>
                
                <div className="button-separator"></div>

                <div onClick={openTagsUpdateModal} className="feature-buttons">
                  <button
                    className="tooltip-button"
                    disabled={!selectedIndex || selectedIndex.length === 0}
                  >
                    {" "}
                    <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                        src={tags}
                        alt="Filter Icon"
                        style={{
                          height: "17px",
                          width: "19px",
                          marginRight: "5px",
                        }}
                      />
                      Update Tags
                    </span>
                    <span className="tooltip-text">Update Tags</span>
                  </button>
                </div>
              </>
            )}
           
          </div>
          {
             (hasContributor)&& ( <>
             <div className="feature-container"  style={{paddingTop:"0"}}>
          <div className="select-container " style={{marginLeft:"0.5%"}}>
                  <select ref={autoManualRef} style={{ width: "150px" }} >
                    <option value="Manual" selected>
                      Manual
                    </option>
                   
                  </select>
                </div>
                <div className="button-container">
                  <button onClick={handleCapacityChange}>
                    Start Capacity Allocation
                  </button>
                </div>

                <div className="button-container">
                  <button
                    className="tooltip-button-ready-to-approve"
                    onClick={openApproval}
                    disabled={
                      !selectedIndex ||
                      selectedIndex?.length === 0 ||
                      !capacityAllocation ||
                      !isReadyForUpdate ||
                      approvalError
                    }
                    >
                    Ready to Approve
                  {approvalError && (
                    <span className="tooltip-text-ready-to-approve">{approvalError}</span>
                  )}
                  </button>
                </div>
          </div>
          </>)}

          <div
            style={{
              overflowY: "hidden",
              overflowX: "auto",
              // overflowY: "auto",
              // height: "70vh",
              width: "98%",
              paddingLeft: "8px",
              paddingRight: "8px",
              userSelect: isCtrlActive ? 'text' : 'none'
            }}
            className="scrollable-table"

          >
            <TableComponent
              handleTabClick={handleTabClick}
              setRegionSums={setRegionSums}
              rowErrors={rowErrors}
              errorLabel={errorLabel}
              capacityAllocation={capacityAllocation}
              handletableChange={handletableChange}
              handleSelectedIndex={handleSelectedIndex}
              selectedIndex={selectedIndex}
              handleTableDataChange={handleTableDataChange}
              tableData={tableData}
              setIsRaedyForUpdate={setIsRaedyForUpdate}
              tableLoader={tableLoader}
              showToast={showToast}
              selectAll={selectAll}
              setSelectAllChange={setSelectAllChange}
              regionSums={regionSums}
            ></TableComponent>
          </div>

          {showBackDrop && <div className="modal-backdrop"></div>}
          {openApprovalModal ? (
            <ApproveRequest
              closeConfirmationModal={closeConfirmationModal}
              data={selectedData}
              selectedIndex={selectedIndex}
            ></ApproveRequest>
          ) : (
            ""
          )}
          {openAddEntryModal ? (
            <Detail
              closeConfirmationModal={closeAddModal}
              data={[]}
              regionGrantedStatusOptions={requestGrantedStatusOptions}
              modelOptions={gpuNameOptions}
              subscriptionOptions={[]}
              gbbRegionOptions={gbbRegionOptions}
              requestStateOption={requestStateOption}
              handletableInputChange={handletableChange}
            >
            </Detail>
          ) : (
            ""
          )}
          {openDeleteAlertModal ? (
            <Alert message={'Are you sure you want to delete the selected requests?'} SubmitbuttonText={'Delete'} onclickSubmit={deleteRecord} deleteSuccess={deleteSuccess} deleteFailure={deleteFailure} deleting={deleting} onClickCancel={closeDeleteAlert}></Alert>
          ) : (
            ""
          )}
          {openTagUpdate ? (
            <UpdateTags
              closeTagUpdate={closeTagUpdate}
              data={newTab}
              selectedIndex={selectedIndex}
              tagOptions={allTags}
            ></UpdateTags>
          ) : (
            ""
          )}
          {openBulkUpdate ? (
            <BulkUpdate
              closeBulkUpdate={closeBulkUpdate}
              data={newTab}
              selectedIndex={selectedIndex}
            ></BulkUpdate>
          ) : (
            ""
          )}

          {OpenMailModel ? (
            <MailModal
              closeMailModal={closeMailModal}
              data={tableData}
              selectedIndex={selectedIndex}
            ></MailModal>
          ) : (
            ""
          )}
        </>
      )}

      {loader && (
        <div className="loader-container" style={{ height: "80vh" }}>
          <div className="loader"></div>
        </div>
      )}
    </>
  );
}

export default MasterTableTab;
